import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DeceasedActionName } from './deceased-workflow';

export { DeceasedActionName } from './deceased-workflow';

export class DeceasedAction {
    static readonly DECEASED_CHANGE_STATE = new DeceasedAction(
        DeceasedActionName.DECEASED_CHANGE_STATE,
        (
            <FormattedMessage
                id='DeceasedAction.deceased_change_state'
                description='The displayed value for the DeceasedAction deceased_change_state'
                defaultMessage='Change deceased state'
            />
        )
    );

    static readonly ALL = [DeceasedAction.DECEASED_CHANGE_STATE];

    constructor(
        public readonly value: DeceasedActionName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(action: string): DeceasedAction | undefined {
        return this.ALL.find((item) => item.value === action);
    }
}
